<template>
  <div>

    <div class="row">
      <div class="col-md-12">
        <measure-form
          :data='data'
        />
      </div>
    </div>

    <div class="text-right">
      <btn-rounded
        label="SALVAR"
        event="save"
      />
    </div>

  </div>
</template>
<script>
  import MeasureForm from "components/UIComponents/Forms/MeasureForm.vue";
  import {mapActions} from "vuex";

  export default {
    components: {
      MeasureForm
    },
    /**
     * Chart data used to render stats, charts. Should be replaced with server data
     */
    data() {
      return {
        data: {}
      };
    },
    created() {
      this.$on("save", () => {
        if (this.data.name != '') {
          this.createMeasure(this.data)
            .then(res => {
              this.$notify({
                group: "foo",
                title: "Sucesso",
                text: res.msg,
                position: "top center",
                type: "success"
              });
              this.data = {};
            })
            .catch(res => {
              this.$notify({
                group: "foo",
                title: res.msg,
                text: res.info,
                position: "top center",
                type: "error"
              });            });
        } else {
          alert("Nome inválida")
        }
      });
    },

    mounted() {
      this.data = !this.$route.params.model ? {} : this.$route.params.model;
    },
    methods: {
      ...mapActions(["createMeasure"]),

    }
  };
</script>
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Measure/MeasureCreate.vue